/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconBulletLevel116 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBulletLevel116(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconBulletLevel120 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBulletLevel120(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path d="M12.5 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconBulletLevel124 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBulletLevel124(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" fill="currentColor" />
        </SVGContainer>
    );
});

export const IconBulletLevel1 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBulletLevel1(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconBulletLevel116 {...iconProps} />;
        case '20':
            return <IconBulletLevel120 {...iconProps} />;
        case '24':
            return <IconBulletLevel124 {...iconProps} />;
        default:
            return <IconBulletLevel124 {...iconProps} />;
    }
});
